import { Tag } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { Chip, ChipId } from '../../utils/chipMapping'

type RolePermissionChipsProps = {
  // The row owns the mapping (it also needs the chip count for the column
  // label), so the chips arrive resolved rather than being derived twice.
  chips: Chip[]
  testId?: string
}

const CHIP_COLORS: Record<ChipId, string> = {
  safeguarding: 'magenta',
  'insights-hub': 'cyan',
  team: 'geekblue',
  'service-user': 'blue',
  incident: 'volcano',
  'download-centre': 'orange',
  medication: 'purple'
}

const CHIP_LABEL_KEYS: Record<ChipId, string> = {
  safeguarding: reportsConstants.TEAM_LIST_CHIP_SAFEGUARDING,
  'insights-hub': reportsConstants.TEAM_LIST_CHIP_INSIGHTS_HUB,
  team: reportsConstants.TEAM_LIST_CHIP_TEAM,
  'service-user': reportsConstants.TEAM_LIST_CHIP_SERVICE_USER,
  incident: reportsConstants.TEAM_LIST_CHIP_INCIDENT,
  'download-centre': reportsConstants.TEAM_LIST_CHIP_DOWNLOAD_CENTRE,
  medication: reportsConstants.TEAM_LIST_CHIP_MEDICATION
}

const StyledChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;

  /* antd Tag ships a default margin-inline-end; zero it so the chip column's
     left edge lines up with the other columns (the flex gap handles spacing). */
  .ant-tag {
    margin-inline-end: 0;
  }
`

const RolePermissionChips: React.FC<RolePermissionChipsProps> = ({
  chips,
  testId
}) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  return (
    <StyledChipRow data-testid={testId}>
      {chips.map((chip) => (
        <Tag
          key={chip.id}
          color={CHIP_COLORS[chip.id]}
          data-testid={testId ? `${testId}-${chip.id}` : undefined}
        >
          {t(CHIP_LABEL_KEYS[chip.id])}
        </Tag>
      ))}
    </StyledChipRow>
  )
}

export default RolePermissionChips
